if (document.readyState !== 'loading') {
    initJobs();
} else {
    document.addEventListener('DOMContentLoaded', () => {
        initJobs();
    });
}

function initJobs() {
    jQuery('.ct-toggle').click(function () {
        let element = this;
        setTimeout(function () {
            jQuery(element).parent().toggleClass('show');
            jQuery(element).next().toggleClass('show');
            jQuery('body').toggleClass('ct-toggle-open');
        }, 50);
    });

    jQuery('body').click(function () {
        if (jQuery(this).hasClass('ct-toggle-open')) {
            jQuery('.ct-toggle').parent().removeClass('show');
            jQuery('.ct-toggle').next().removeClass('show');
            jQuery(this).removeClass('ct-toggle-open');
        }
    });
}
